/**
 * Blog programme — external citation links.
 *
 * CCC-PUBLISH-BRIEF.md section 4.6: citations to PubMed, NIAAA, FDA and
 * journals open in a new tab with rel="noopener", and must NOT be nofollowed.
 * They are load-bearing for E-E-A-T.
 *
 * Applied at render time rather than baked into the body HTML, because the
 * markdown in source/blog/drafts is the source of record and the Shopify
 * bodies are generated from it — an attribute added by hand in the admin
 * would be erased by the next regenerate-and-push.
 *
 * Progressive enhancement: without JS the links still work, just in the same
 * tab. Nothing here can break a link.
 *
 * Deliberately NOT touched:
 *   - internal /blogs/news/... and /products/... links (same-tab by design)
 *   - anchors that already declare a target
 *   - rel="nofollow" is never added; see 4.6
 */
(function () {
  var root = document.querySelector('.blog-post-content');
  if (!root) return;

  var origin = window.location.origin;

  root.querySelectorAll('a[href]').forEach(function (a) {
    if (a.hasAttribute('target')) return;

    var href = a.getAttribute('href') || '';
    // Relative, hash and mailto/tel stay in place.
    if (!/^https?:\/\//i.test(href)) return;

    var url;
    try { url = new URL(href, origin); } catch (e) { return; }
    if (url.origin === origin) return; // same-site absolute link

    a.setAttribute('target', '_blank');

    // Preserve any existing rel tokens; add noopener (and noreferrer for the
    // referrer leak) without ever introducing nofollow.
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') === -1) rel.push('noopener');
    if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
    a.setAttribute('rel', rel.join(' '));
  });
})();
